'use strict';
import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';
import Cabecera from './Cabecera';
import SeccionDatosGenerales from './SeccionDatosGenerales/SeccionDatosGenerales';
import SeccionRenglonesModelo from './SeccionRenglonesModelo/SeccionRenglonesModelo';

/* MODALES */
import ModalAltaEdicionRenglonContable from './Modales/ModalAltaEdicionRenglonContable/ModalAltaEdicionRenglonContable';
import ModalConfirmarAbandonoABMModelos from './Modales/ModalConfirmarAbandonoABMModelos/ModalConfirmarAbandonoABMModelos';
import ModalConfirmarEliminacionRenglon from './Modales/ModalConfirmarEliminacionRenglon/ModalConfirmarEliminacionRenglon';
import ModalCopiarRenglonContable from './Modales/ModalCopiarRenglonContable/ModalCopiarRenglonContable';
import ModalReemplazarCuentasContables from './Modales/ModalReemplazarCuentasContables/ModalReemplazarCuentasContables';
import ModalResultadoReemplazarCuentasContables from './Modales/ModalResultadoReemplazarCuentasContables/ModalResultadoReemplazarCuentasContables';
import ModalMensajeResultado from './Modales/ModalMensajeResultado/ModalMensajeResultado';

class ABMModelos extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
          window.onbeforeunload = function (event) {
            if (sessionStorage.getItem('PantallaCambios') == "true") {
              return "¿Quieres salir de este sitio web? Es posible que los cambios no se guarden.";
            }
          };
        this.props.actions.cargarInformacionABMModelos(this.props.currentScope, this.props.match.params.id, this.props.executionContext);
    }

    componentWillUnmount() {
       
        this.props.actions.resetState();
        window.onbeforeunload = null;
    }

    render() {
        const {
            cantidadModelos,
            cantidadRenglones,
            cargarInformacionTipoMovimientos,
            checksABMModelos,
            combosABMModelos,
            criteriosRenglon,
            datosMakerChecker,
            datosPantalla,
            datosRenglones,
            datosRenglonesExcel,
            errorValidacion,
            indicadoresInterfazActivos,
            inputsABMModelos,
            marcasActivas,
            mensajeValidacionRenglonesIguales,
            modalAltaEdicionRenglonContable,
            modalCopiarRenglonContable,
            modalConfirmarAbandonoABMModelos,
            modalConfirmarBorrarRenglon,
            modalMensajeResultado,
            modalReemplazarCuentasContables,
            modalResultadoReemplazarCuentasContables,
            modeloEdicion,
            modelosContables,
            monedasActivas,
            mostrarSpinnerABMModelos,
            mostrarSpinnerModales,
            mostrarSpinnerModalRenglones,
            nroRenglon,
            opcionElegida,
            actualizarOpcionElegida,
            permisosUsuario,
            radioButtonsABMModelos,
            redireccionarPantallaPrincipal,
            redirect,
            registroDesplegado,
            renglonEdicion,
            sagaId,
            seAgregaRenglon,
            seImportaModelo,
            sucursalesActivas,
            sugerenciaModelo,
            comboTiposMovimientos
        } = this.props.data;

        const { actions } = this.props;

        if (redirect.shouldRedirect)
            return <Redirect to={redirect.to} push />;

        const dataModeloEdicion = modelosContables.filter(mc => mc.Codigo == modeloEdicion)[0];
        const esEdicion = Boolean(modeloEdicion);
        const soloLectura = !permisosUsuario.Baja && !permisosUsuario.Modificacion;
        const modalActivo = modalAltaEdicionRenglonContable;
        const mostrarMakerChecker = esEdicion && datosMakerChecker.filter(mc=> mc.SiNoConfirmacionModelo == true)[0];
        const permisoBotonMakerChecker = permisosUsuario.Confirmacion;


        const body = modalActivo ? 
                                    null 
                                : 
                                    <div>
                                        <Cabecera                                           
                                            actualizarOpcionElegida={actions.actualizarOpcionElegida}
                                            actualizarConfirmacionModelo = {actions.actualizarConfirmacionModelo}
                                            buscarModelosImportar={actions.buscarModelosImportar}
                                            datosEdicionRenglon={actions.datosEdicionRenglon}
                                            importarModelo={actions.importarModelo}
                                            mostrarOcultarImportarModelos={actions.mostrarOcultarImportarModelos}
                                            mostrarOcultarModalABMModelos={actions.mostrarOcultarModalABMModelos}
                                            mostrarOcultarResultadosImportarModelos={actions.mostrarOcultarResultadosImportarModelos}
                                            routeToModelosContables={actions.routeToModelosContables}
                                            validarGuardarModelo={actions.validarGuardarModelo}
                                           
                                            mostrarMakerChecker={mostrarMakerChecker}
                                            dataModeloEdicion={dataModeloEdicion}
                                            datosPantalla={datosPantalla}
                                            descripcionModeloSeleccionadoImportar={inputsABMModelos.descripcionModeloSeleccionadoImportar}
                                            esEdicion={esEdicion}
                                            inputImportarModelo={inputsABMModelos.inputImportarModelo}
                                            modelosFiltradosImportarModelo={inputsABMModelos.modelosFiltradosImportarModelo}
                                            modeloSeleccionadoImportar={inputsABMModelos.modeloSeleccionadoImportar}
                                            mostrarResultadosImportarModelo={inputsABMModelos.mostrarResultadosImportarModelo}
                                            permisoBotonMakerChecker={permisoBotonMakerChecker}
                                            permisoAlta={permisosUsuario.Alta}
                                            permisoBaja={permisosUsuario.Baja}
                                            permisoModificacion={permisosUsuario.Modificacion}
                                            seImportaModelo={seImportaModelo}
                                            soloLectura={soloLectura}
                                        />

                                        <SeccionDatosGenerales
                                            buscarIndicadoresInterfaz={actions.buscarIndicadoresInterfaz}
                                            cambiarCheckABMModelos={actions.cambiarCheckABMModelos}
                                            cambiarOpcionCombo={actions.cambiarOpcionCombo}
                                            cambiarValorInput={actions.cambiarValorInput}
                                            mostrarOcultarResultadosIndicadorInterfaz={actions.mostrarOcultarResultadosIndicadorInterfaz}
                                            seleccionarRadioButtonABMModelos={actions.seleccionarRadioButtonABMModelos}

                                            checkAperturaPorSocio={checksABMModelos.checkAperturaPorSocio}
                                            checkAperturaPorSucursal={checksABMModelos.checkAperturaPorSucursal}
                                            checkConfirmacionAutomatica={checksABMModelos.checkConfirmacionAutomatica}
                                            checkModeloHabilitado={checksABMModelos.checkModeloHabilitado}
                                            checkRequiereReverso={checksABMModelos.checkRequiereReverso}
                                            comboSucursal={combosABMModelos.comboSucursal}
                                            datosPantalla={datosPantalla}
                                            datosRenglones={datosRenglones}
                                            descripcionIndicadorInterfazSeleccionado={inputsABMModelos.descripcionIndicadorInterfazSeleccionado}
                                            errorValidacion={errorValidacion}
                                            esEdicion={esEdicion}
                                            indicadoresInterfazActivos={indicadoresInterfazActivos}
                                            indicadorInterfazFiltrados={inputsABMModelos.indicadorInterfazFiltrados}
                                            indicadorInterfazSeleccionado={inputsABMModelos.indicadorInterfazSeleccionado}
                                            inputCodigoModelo={inputsABMModelos.inputCodigoModelo}
                                            inputIndicadorInterfaz={inputsABMModelos.inputIndicadorInterfaz}
                                            inputNombreModelo={inputsABMModelos.inputNombreModelo}
                                            inputDiasDiferimiento={inputsABMModelos.inputDiasDiferimiento}
                                            marcasActivas={marcasActivas}
                                            monedasActivas={monedasActivas}
                                            mostrarResultadosIndicadorInterfaz={inputsABMModelos.mostrarResultadosIndicadorInterfaz}
                                            permisoAlta={permisosUsuario.Alta}
                                            permisoBaja={permisosUsuario.Baja}
                                            permisoModificacion={permisosUsuario.Modificacion}
                                            radioButtonsABMModelos={radioButtonsABMModelos}
                                            sucursalesActivas={sucursalesActivas}
                                            sugerenciaModelo={sugerenciaModelo}
                                        />

                                        <SeccionRenglonesModelo 
                                            agregarEliminarRenglonContable={actions.agregarEliminarRenglonContable}
                                            cargarValoresModalCopiarRenglonContable={actions.cargarValoresModalCopiarRenglonContable}
                                            datosEdicionRenglon={actions.datosEdicionRenglon}
                                            mostrarOcultarDatosAdicionalesRenglon={actions.mostrarOcultarDatosAdicionalesRenglon}
                                            mostrarOcultarModalABMModelos={actions.mostrarOcultarModalABMModelos}
                                            descargarExcel={actions.descargarExcel}
                                            armarDatosExportacionExcel={actions.armarDatosExportacionExcel}

                                            inputCodigoModelo={inputsABMModelos.inputCodigoModelo}
                                            criteriosRenglon={criteriosRenglon}
                                            datosRenglones={datosRenglones}
                                            datosRenglonesExcel={datosRenglonesExcel}
                                            errorValidacion={errorValidacion}
                                            esEdicion={esEdicion}
                                            mensajeValidacionRenglonesIguales={mensajeValidacionRenglonesIguales}
                                            permisoAlta={permisosUsuario.Alta}
                                            permisoModificacion={permisosUsuario.Modificacion}
                                            registroDesplegado={registroDesplegado}
                                        />
                                    </div>


        return (
            <div className="ABMModelos">
                {mostrarSpinnerABMModelos ?
                    <div id="loading" className="loading" />
                :
                    body
                }

                {modalAltaEdicionRenglonContable ?
                    <ModalAltaEdicionRenglonContable 
                        buscarCuentasContables={actions.buscarCuentasContables}
                        cambiarInputActivo={actions.cambiarInputActivo}
                        cambiarOpcionCombo={actions.cambiarOpcionCombo}
                        cambiarOpcionComboCriterios={actions.cambiarOpcionComboCriterios}
                        cambiarValorInput={actions.cambiarValorInput}
                        cargarInformacionTipoMovimientos={actions.cargarInformacionTipoMovimientos}
                        cargarInformacionComboImporte={actions.cargarInformacionComboImporte}
                        cargarInformacionCriteriosContables={actions.cargarInformacionCriteriosContables}
                        checkAperturaPorSocio={checksABMModelos.checkAperturaPorSocio}
                        combosABMModelos={combosABMModelos}
                        comboCentroDeCosto={combosABMModelos.modalAltaEdicionRenglonContable.comboCentroDeCosto}
                        comboCentroCostoSeleccionado={combosABMModelos.modalAltaEdicionRenglonContable.comboCentroCostoSeleccionado}
                        comboCampoImporte={combosABMModelos.modalAltaEdicionRenglonContable.comboCampoImporte}
                        comboCampoImporteSeleccionado={combosABMModelos.modalAltaEdicionRenglonContable.comboCampoImporteSeleccionado}
                        comboModalAltaEdicionRenglonContable={combosABMModelos.modalAltaEdicionRenglonContable}
                        comboTipoMovimientoSeleccionado = {combosABMModelos.modalAltaEdicionRenglonContable.comboTipoMovimientoSeleccionado}
                        contenedorCombosCriteriosContables = {combosABMModelos.modalAltaEdicionRenglonContable.contenedorCombosCriteriosContables}
                        cuentasContablesFiltradas={inputsABMModelos.modalAltaEdicionRenglonContable.cuentasContablesFiltradas}
                        cuentaSeleccionada={inputsABMModelos.modalAltaEdicionRenglonContable.cuentasSeleccionadas.inputCuentaContable}
                        errorValidacion={errorValidacion}
                        elegirOpcionSelector={actions.elegirOpcionSelector}
                        guardarValorInput={actions.guardarValorInput}
                        inputActivo={inputsABMModelos.modalAltaEdicionRenglonContable.inputActivo}
                        limpiarMensajeErrorPorNombre={actions.limpiarMensajeErrorPorNombre}
                        inputsAltaEdicionRenglonContable ={inputsABMModelos.modalAltaEdicionRenglonContable}
                        mostrarOcultarModalAltaEdicionRenglonContable={actions.mostrarOcultarModalABMModelos}
                        seleccionarRadioButtonABMModelos={actions.seleccionarRadioButtonABMModelos}
                        seleccionarRbDefaultCuentas= {actions.seleccionarRbDefaultCuentas}
                        seleccionarRbDefaultSocios= {actions.seleccionarRbDefaultSocios}
                        setMostrarLinkVerMas= {actions.setMostrarLinkVerMas}
                        validarGuardarModalAltaEdicionRenglon={actions.validarGuardarModalAltaEdicionRenglon}
                        
                        inputsModal={inputsABMModelos.modalAltaEdicionRenglonContable}
                        rbModalAltaEdicionRenglonContable={radioButtonsABMModelos.modalAltaEdicionRenglonContable}
                        renglonEdicion={renglonEdicion}
                        rbMarca = {radioButtonsABMModelos.rbMarca}
                        comboTiposMovimientos={combosABMModelos.modalAltaEdicionRenglonContable.comboTiposMovimientos}
                        mostrarSpinnerModalRenglones={mostrarSpinnerModalRenglones}

                    />
                :
                    null
                }

                {modalCopiarRenglonContable ?
                    <ModalCopiarRenglonContable
                        buscarCuentasContables={actions.buscarCuentasContables}
                        cambiarInputActivo={actions.cambiarInputActivo}
                        cambiarValorInput={actions.cambiarValorInput}
                        guardarValorInput={actions.guardarValorInput}
                        limpiarMensajeError={actions.limpiarMensajeError}
                        mostrarOcultarModalCopiarRenglonContable={actions.mostrarOcultarModalABMModelos}
                        seleccionarRadioButtonABMModelos={actions.seleccionarRadioButtonABMModelos}
                        validarGuardarCopiaRenglon={actions.validarGuardarCopiaRenglon}

                        cuentasContablesFiltradas={inputsABMModelos.modalCopiarRenglonContable.cuentasContablesFiltradas}
                        cuentaSeleccionada={inputsABMModelos.modalCopiarRenglonContable.cuentasSeleccionadas.inputCuentaContable}
                        errorValidacion={errorValidacion}
                        inputActivo={inputsABMModelos.modalCopiarRenglonContable.inputActivo}
                        inputsCopiarRenglonContable={inputsABMModelos.modalCopiarRenglonContable}
                        mostrarSpinnerModales={mostrarSpinnerModales}
                        rbModalCopiarRenglonContable={radioButtonsABMModelos.modalCopiarRenglonContable}
                        ultimoNumeroRenglon={inputsABMModelos.modalCopiarRenglonContable.ultimoNumeroRenglon}
                    />
                :
                    null
                }
                
                {modalReemplazarCuentasContables ?
                    <ModalReemplazarCuentasContables
                        buscarCuentasContables={actions.buscarCuentasContables}
                        buscarModelosModalReemplazarCuentasContables={actions.buscarModelosModalReemplazarCuentasContables}
                        cambiarCuentasContables={actions.cambiarCuentasContables}
                        cambiarEstadoCheckABMModelos={actions.cambiarEstadoCheckABMModelos}
                        cambiarInputActivo={actions.cambiarInputActivo}
                        cambiarInputBuscadorModelosActivo={actions.cambiarInputBuscadorModelosActivo}
                        guardarQuitarModeloSeleccionado={actions.guardarQuitarModeloSeleccionado}
                        guardarValorInput={actions.guardarValorInput}
                        mostrarOcultarModalReemplazarCuentasContables={actions.mostrarOcultarModalABMModelos}

                        checkReemplazarEnOtrosModelos={checksABMModelos.modalReemplazarCuentasContables.checkReemplazarEnOtrosModelos}
                        cuentasContablesReemplazarCon={inputsABMModelos.modalReemplazarCuentasContables.cuentasContablesFiltradasReemplazarCon}
                        cuentasContablesReemplazarCuenta={inputsABMModelos.modalReemplazarCuentasContables.cuentasContablesFiltradasReemplazarCuenta}
                        cuentasSeleccionadas={inputsABMModelos.modalReemplazarCuentasContables.cuentasSeleccionadas}
                        errorValidacion={errorValidacion}
                        esEdicion={esEdicion}
                        inputActivo={inputsABMModelos.modalReemplazarCuentasContables.inputActivo}
                        inputsBuscador={inputsABMModelos.modalReemplazarCuentasContables}
                        inputModelos={inputsABMModelos.modalReemplazarCuentasContables.inputModelos}
                        modeloEdicion={modeloEdicion}
                        modelosContablesFiltrados={inputsABMModelos.modalReemplazarCuentasContables.modelosContablesFiltrados}
                        modelosSeleccionados={inputsABMModelos.modalReemplazarCuentasContables.modelosSeleccionados}
                        mostrarSpinnerModales={mostrarSpinnerModales}
                        mostrarVerMas={inputsABMModelos.modalReemplazarCuentasContables.mostrarVerMas}
                        ocultarBotonVerMas={actions.ocultarBotonVerMas}                        
                     />
                :
                    null
                }

                {modalConfirmarBorrarRenglon ?
                    <ModalConfirmarEliminacionRenglon
                        agregarEliminarRenglonContable={actions.agregarEliminarRenglonContable}
                        mostrarOcultarModalConfirmarEliminacionRenglon={actions.mostrarOcultarModalABMModelos}

                        nroRenglon={nroRenglon}
                        seAgregaRenglon={seAgregaRenglon}
                    />
                :
                    null
                }
     
                {modalConfirmarAbandonoABMModelos ?
                    <ModalConfirmarAbandonoABMModelos
                        mostrarOcultarModalConfirmarAbandonoABMModelos={actions.mostrarOcultarModalABMModelos}
                        routeToModelosContables={actions.routeToModelosContables}
                        validarGuardarModelo={actions.validarGuardarModelo}

                        opcionElegida={opcionElegida}
                    />
                :
                    null
                }

                {modalResultadoReemplazarCuentasContables ?
                    <ModalResultadoReemplazarCuentasContables
                        mostrarOcultarModalConfirmarEliminacionRenglon={actions.mostrarOcultarModalABMModelos}

                        cantidadModelos={cantidadModelos}
                        cantidadRenglones={cantidadRenglones}
                        huboError={errorValidacion.modalResultadoReemplazarCuentasContables}
                        sagaId={sagaId}
                    />
                :
                    null
                }

                {modalMensajeResultado != "" ?
                    <ModalMensajeResultado
                        mostrarOcultarModal={actions.mostrarOcultarModalABMModelos}
                        routeToModelosContables={actions.routeToModelosContables}

                        mensaje={modalMensajeResultado}
                        redireccionarPantallaPrincipal={redireccionarPantallaPrincipal}
                    />
                :
                    null
                }
            </div>
        );
    }
}

export default ABMModelos;